import { BrowserRouter, Routes, Route } from "react-router-dom";
import CommonWrapper from "./components/Common/CommonWrapper";
import Dashboard from "../src/components/User/Dashboard/Index";
import StakingPool from "../src/components/User/StakingPool/Index";
import Transaction from "../src/components/User/Transaction/Index";
import Chats from "../src/components/User/Chats/Index";
import IdentityData from "../src/components/User/IdentityData/Index";
import Investments from "../src/components/User/Investments/Index";
import IncomeData from "../src/components/User/IncomeData/Index";
import Balances from "../src/components/User/Balances/Index";
import Liabilities from "../src/components/User/Liabilities/Index";
import StudentLoans from "../src/components/User/StudentLoans/Index";
import CreditCards from "../src/components/User/CreditCards/Index";
import TransactionHistory from "../src/components/User/TransactionHistory/Index";
import Login from "../src/components/User/Login/Index";
import SignUp from "../src/components/User/SignUp/Index";
import KycForm from "./components/User/KycForm";
import Chat from "./pages/Chat";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={
              <CommonWrapper>
                <Dashboard />
              </CommonWrapper>
            }
          />
          <Route
            path="/staking-pool"
            element={
              <CommonWrapper>
                <StakingPool />
              </CommonWrapper>
            }
          />
          <Route
            path="/transaction"
            element={
              <CommonWrapper>
                <Transaction />
              </CommonWrapper>
            }
          />
          {/*<Route
            path="/chat"
            element={
              <CommonWrapper>
                <Chats />
              </CommonWrapper>
            }
          />*/}
          <Route
            path="/investments"
            element={
              <CommonWrapper>
                <Investments />
              </CommonWrapper>
            }
          />
          <Route
            path="/identity-data"
            element={
              <CommonWrapper>
                <IdentityData />
              </CommonWrapper>
            }
          />
          <Route
            path="/income-data"
            element={
              <CommonWrapper>
                <IncomeData />
              </CommonWrapper>
            }
          />
          <Route
            path="/balances"
            element={
              <CommonWrapper>
                <Balances />
              </CommonWrapper>
            }
          />
          <Route
            path="/liabilities"
            element={
              <CommonWrapper>
                <Liabilities />
              </CommonWrapper>
            }
          />
          <Route
            path="/student-loans"
            element={
              <CommonWrapper>
                <StudentLoans />
              </CommonWrapper>
            }
          />
          <Route
            path="/credit-cards"
            element={
              <CommonWrapper>
                <CreditCards />
              </CommonWrapper>
            }
          />
          <Route
            path="/transaction-history"
            element={
              <CommonWrapper>
                <TransactionHistory />
              </CommonWrapper>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/form" element={<KycForm />} />
          <Route
            path="/chat"
            element={
              <CommonWrapper>
                <Chat />
              </CommonWrapper>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
